


































































import { Component, Vue } from 'vue-property-decorator';
import LoadingBox from '@/components/common/LoadingBox.vue';
import {
  getTotalQuestionsBySubject,
  SubjectQuestions,
} from '@/utils/add-question/add-question-util';
import getLevel from '@/utils/common/get-level';

@Component({
  components: { LoadingBox },
})
export default class AdminQuestionMonitor extends Vue {
  isLoading = true;
  subjectQuestions: SubjectQuestions | null = null;

  get subjectUuid() {
    return this.$route.params.uuid;
  }

  async created() {
    if (this.subjectUuid) {
      this.subjectQuestions = await getTotalQuestionsBySubject(
        this.subjectUuid,
      );
    }

    this.isLoading = false;
  }

  getLevelLabel(level: number) {
    return getLevel(level);
  }

  get getTotalColumns() {
    if (!this.subjectQuestions) return null;

    let totalQuestions = 0;
    let totalPublishQuestion = 0;
    let totalDraftQuestion = 0;

    let totalObjQuestions = 0;
    let totalObjPublishQuestion = 0;
    let totalObjDraftQuestion = 0;

    let totalSubjQuestions = 0;
    let totalSubjPublishQuestion = 0;
    let totalSubjDraftQuestion = 0;

    this.subjectQuestions.forms.forEach(form => {
      totalQuestions += form.totalQuestion;
      totalPublishQuestion += form.totalPublishQuestion;
      totalDraftQuestion += form.totalDraftQuestion;

      totalObjQuestions += form.objective.totalQuestion;
      totalObjPublishQuestion += form.objective.totalPublishQuestion;
      totalObjDraftQuestion += form.objective.totalDraftQuestion;

      totalSubjQuestions += form.subjective.totalQuestion;
      totalSubjPublishQuestion += form.subjective.totalPublishQuestion;
      totalSubjDraftQuestion += form.subjective.totalDraftQuestion;
    });

    return {
      totalQuestions,
      totalPublishQuestion,
      totalDraftQuestion,
      totalObjQuestions,
      totalObjPublishQuestion,
      totalObjDraftQuestion,
      totalSubjQuestions,
      totalSubjPublishQuestion,
      totalSubjDraftQuestion,
    };
  }
}
